import store from './index';
export const confirmationDialog = (data) => store.commit('SET_OPEN_CONFIRMATION_DIALOG', {
    header: data.header,
    body: data.body,
    confirmationFunction: data.confirmFn,
    confirmationArgument: null,
    withTimer: data.options?.withTimer ?? false,
    disableCancel: data.options?.disableCancel ?? false,
    requiresPin: data.options?.requiresPin ?? false
});
